up.compiler(".up_toogle", function (_element, data) {
  const amt = `<span class="font-bold font-montserrat w-12 mx-auto inline-flex items-center justify-center rounded-2xl bg-white border-2 border-[#B3C1BA] px-2 py-1 text-xs  text-[#B3C1BA] ring-1 ring-gray-500/10 ring-inset">Pro</span>`;
  const pro = `<span class="font-bold font-montserrat w-12 mx-auto inline-flex items-center justify-center rounded-2xl bg-[#23d166] px-2 py-1 text-xs  text-foreground ring-1 ring-green-600/20 ring-inset">Pro</span>`;

  const badge = document.querySelector(`.js-xbadge[data-slug="${data.slug}"]`);
  const isPro = data.ispro === "true";
  if (badge) {
    badge.innerHTML = isPro ? pro : amt;
    badge.setAttribute("data-ispro", data.ispro);
  } else {
    window.location.reload();
  }
});
